import { useState } from "react";
import useFetchStandard from "../../../hooks/usFetchStandard";
import { GetAccess } from "../../../utils/RolesandAccess";
import Swal from "sweetalert2";
import axiosInstance from "../../../services/axiosComman";
import { toast } from "react-toastify";
import ModelBox from "./ShowData";

function StandardResettingIndex() {
  const { standardFullList,getAllStandard } = useFetchStandard();
  const [show,setShow] = useState(false)
  const [standardName, setStandardName] = useState("");

  const handleReset = async (idx,name) => {
    setStandardName(name)
      Swal.fire({
        title: `Are you sure you want to Reset standard ${name||""} ?`,
        html:`All current information of Standard ${name||""} will be archived into Reports. <br>
        Archived information cannot be edited.<br>
        Information on archived standard can be viewed in Reports section.`,
        icon: 'warning',
        confirmButtonColor: '#3AB54A',          
        confirmButtonText: 'Yes',
        showCancelButton: true,
        cancelButtonColor: '#d5d5d5',
        cancelButtonText:"No",
        width:"45%",
      }).then(async (result) => {
        if (result.isConfirmed) {
          if (idx) {
            setShow(true);
            handleResetFunction(idx,name);
          }
        }
      })
    }

    function handleResetFunction(idx,name){
        axiosInstance.get(`/Standards/data_reset/${idx}`)
        .then( async (res) => {
          setShow(false);
          setStandardName("")
          if (res.data?.status) {
            getAllStandard()
            toast.success(
                <p className="test-sm">
                  {`${res.data.msg || res.data.message}` ||
                    "User Added Successfully"}
                </p>
              );
            await Swal.fire({
              icon:"success",
              title: `Reset standard ${name||""} completed.`,
              html:`Go to SETTINGS – Certification Calendar Tracker page <br>
              Input new START Date and END Date <br>
              For METASCROLL to create and tracker activities for new Calendar<br>
              Click here to close this window
              `,
              width:"35%",
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Close',
            });
          } else {
            toast.warning(
                <p className="test-sm">
                  {`${res.data.msg || res.data.message}` ||
                    "User Added Unsuccessfully"}
                </p>
              );
          }
        })
        .catch((err) => {
          setShow(false);
          setStandardName("")
          toast.error(
            <p className="test-sm">{`${
              err.response.data.msg ||
              err.response.data.message ||
              err.response.data.error ||
              "User Added Unsuccessfully"
            }`}</p>
          );
        });
      }

  return (
    <>
        <div className=" w-full h-[calc(100vh-140px)] overflow-y-auto">
      <div className="pb-2 px-2 flex justify-between items-center w-full">
        <h4 className="text-sm 2xl:text-base font-medium text-heading">
          Reset the Standard
        </h4>
      </div>
      <div className=" w-full h-[calc(100vh-180px)]  relative overflow-y-auto pb-5">
        {
            standardFullList.map((item, index) => (
                <div className='pl-5 mt-3 w-[98.5%] flex justify-between items-center' key={index}>
                <div className=' w-[80%] flex items-center gap-4'>
                <div className=' w-32 h-32 p-2 rounded-md flex justify-center items-center shadow-box overflow-hidden'>
                 {
                     item?.image_path !=null && item?.image_path !="" ? <img src={item?.image_path} width="110%" alt="#" /> : <p className=' text-primary font-medium text-4xl'>{item?.name&&item?.name.charAt(0)||""}</p>
                 }
                </div>
                 <div className=' text-sm'>{item?.name||"-"}</div>
                 </div> 
                 <div>
                {
                  GetAccess('data_reset') && <button className=' bg-primary text-white px-3 py-1 shadow-box rounded-md' onClick={()=>handleReset(item?.id,item?.name)}>Reset</button>
                }  
                </div>
               </div>
            ))
        }
      </div>
    </div>
    <ModelBox 
       visible={show}
       onClose={()=>setShow(false)}
       name={standardName}
      />
    </>
  );
}

export default StandardResettingIndex;
